import { render, staticRenderFns } from "./StepManualFinish.vue?vue&type=template&id=232c64d5&"
import script from "./StepManualFinish.vue?vue&type=script&lang=js&"
export * from "./StepManualFinish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports